import React from 'react';
import { computationDecimalScale, computationValueLength } from '../../../../common/helper';
import FormsyInputField from '../../../elements/FormsyInputField';
import FormsySelect from '../../../elements/FormsySelect';
import FormFields from "../../formFields/computation.json";
const IS_ADVANCE_DEALER_PAYOUT = FormFields?.IS_ADVANCE_DEALER_PAYOUT;
const ADVANCE_DEALER_PAYOUT = FormFields?.ADVANCE_DEALER_PAYOUT;

const AdvanceDealerPayout = ({
    computationDetails,
    allfieldsReadonly,
    isRegeneratedFieldActive,
    financierId,
    lead,
    handleRadioChange,
    adpPerValue,
    handleADPChange,
    isFinssoAccountSelected
}) => {
    return <section className='loan-detail-filed-bg'>
        <h2>Advance Dealer Payout</h2>
        {IS_ADVANCE_DEALER_PAYOUT.filter(field => {
            if (field.id === "finsso_transfer" && computationDetails?.adp_type !== "Yes") {
                return false;
            }
            return true;
        }).map((field) => (
            <fieldset
                key={field.id}
                className="form-filed col-md-12 radio-btn radio-type-txt"
            >
                <label className="form-label">{field.label}</label>
                {field.options.map((option) => (
                    <div className="custom-control custom-checkbox" key={option.value}>
                        <input
                            id={option.value}
                            type="radio"
                            className="custom-control-input"
                            name={option.name}
                            value={option.value}
                            checked={option.value === computationDetails?.[option.name]}
                            defaultChecked={option.value === lead?.leadDetail?.lead_computation_details?.[option.name]}
                            onChange={handleRadioChange}
                            disabled={allfieldsReadonly || (field.id === "adp_type" && option.value === "Yes" && computationDetails?.final_loan_value < 1) || isRegeneratedFieldActive(field?.name)}
                        />
                        <label htmlFor={option.id} className="custom-control-label">{option.label}</label>
                    </div>
                ))}
            </fieldset>
        ))}
        {(computationDetails?.adp_type === "Yes") &&
            ADVANCE_DEALER_PAYOUT.map((field) => {
                if (
                ["text", "number-format"].includes(field.type) &&
                ((field.name === "adp_percentage_value" && adpPerValue) || field.name !== "adp_percentage_value")
                ) {
                    const isSurchargeField = field.name === "surcharge_for_adp";
                    const isFinssoTransferYes = isFinssoAccountSelected(); 
                return (
                    <fieldset key={field.id} className="form-filed col-md-12">
                    <FormsyInputField
                        id={field.id}
                        name={field.name}
                        type={field.type}
                        value={computationDetails?.[field.name]}
                        placeholder=" "
                        label={field.label}
                        onChange={(data) => handleADPChange(data, field.name)}
                        format={field.ApplyNumberformat || ""}
                        validations={field.validations}
                        validationError={(computationDetails?.[field.name] && field.validationError) || ""}
                        readOnly={field.readOnly || allfieldsReadonly || isRegeneratedFieldActive(field?.name) ||    (isSurchargeField && isFinssoTransferYes)}
                        required={field.required}
                        decimalScale={computationDecimalScale(financierId)}
                        valueLength={computationValueLength(financierId)}
                    />
                    </fieldset>
                );
                } else if (field.type === "dropdown") {
                return (
                    <fieldset key={field.id} className="single-select col-md-12">
                    <FormsySelect
                        name={field.name}
                        id={field.id}
                        inputProps={{
                        options: field?.options,
                        placeholder: field.label,
                        className: "react-select",
                        classNamePrefix: "react-select",
                        value: field?.options.filter(({ value }) => value === computationDetails?.[field.name]),
                        isDisabled: field.readOnly || allfieldsReadonly || isRegeneratedFieldActive(field?.name),
                        }}
                        required={field.required}
                        value={field?.options}
                        onChange={(data) => handleADPChange(data, field.name)}
                    />
                    </fieldset>
                );
                } else if (field.type === "radio") {
                return (
                    <fieldset key={field.id} className="form-filed col-md-12 radio-btn radio-type-txt">
                    <label className="form-label">{field.label}</label>
                    {field.options.map((option) => (
                        <div className="custom-control custom-checkbox" key={option.value}>
                        <input
                            id={option.value}
                            type="radio"
                            className="custom-control-input"
                            name={option.name}
                            value={option.value}
                            checked={option.value?.toString() === computationDetails?.[option.name]?.toString()}
                            onChange={handleRadioChange}
                            disabled={allfieldsReadonly || isRegeneratedFieldActive(field?.id)}
                        />
                        <label htmlFor={option.id} className="custom-control-label">{option.label}</label>
                        </div>
                    ))}
                    </fieldset>
                );
                }

                return null;
            })}

    </section>;
};


export default AdvanceDealerPayout;

